export const Logo = ({ size = "md", onClick }) => {
  const dims = size === "sm" ? "h-8 w-8" : size === "lg" ? "h-11 w-11" : "h-9 w-9";
  const text = size === "sm" ? "text-lg" : size === "lg" ? "text-2xl" : "text-lg sm:text-xl";
  return (
    <div className={`flex items-center gap-2 sm:gap-2.5 min-w-0 ${onClick ? "cursor-pointer" : ""}`} onClick={onClick} data-testid="brand-logo">
      <div className={`${dims} shrink-0 rounded-xl bg-gradient-to-br from-indigo-500 via-cyan-400 to-pink-500 flex items-center justify-center mg-glow`}>
        <svg viewBox="0 0 24 24" className="h-1/2 w-1/2 text-white" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 17l4-8 4 5 3-6 4 9" />
        </svg>
      </div>
      <span className={`font-display font-extrabold tracking-tight whitespace-nowrap ${text}`}>
        Monaga <span className="mg-gradient-text">Adflow</span>
      </span>
    </div>
  );
};

export default Logo;
